import React from 'react';
import TMReports from '../ReusedComponents/TMReports'

export default function TMSAReports() {
    return (
        <TMReports userType={"superadmin"} />
    );
}
